import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { fetchNasHealth, type NasHealth } from './nasApi'

/**
 * Qurilmalarning tiriklik belgisi — bitta so'rov, jadval bo'ylab
 * ishlatiladi.
 *
 * <h2>⚠️ Nega bitta so'rov, qator boshiga bittadan emas</h2>
 * Ustunning `render` ichida `useQuery` chaqirish 250 ta qurilmada 250 ta
 * so'rov bo'lardi (va React qoidasi bo'yicha umuman mumkin emas). Backend
 * ham shuni hisobga olib BARCHA qurilmani bitta guruhlangan SQL bilan
 * qaytaradi.
 *
 * <h2>⚠️ 30 soniyalik yangilanish — qayerdan olingan</h2>
 * Jonli qurilmada Interim-Update oralig'i 59–61 s (o'lchangan). Undan tez
 * so'rash yangi ma'lumot BERMAYDI — bir xil qatorni ikki marta o'qiydi.
 * Undan sekin so'rash esa uzilishni chegaradan (≈3 daqiqa) keyin ham
 * ko'rsatmay turardi. 30 s — oraliqning yarmi: har yangi Interim panelga
 * bir davr ichida yetib keladi.
 *
 * ⚠️ `refetchInterval` faqat SHU so'rovga tegishli. NAS ro'yxati
 * (`DataTable`) avtomatik yangilanmaydi va shunday qolishi kerak:
 * sozlama o'zi-o'zidan o'zgarmaydi, lekin operator tahrirlash oynasini
 * ochib turganda ro'yxat oyoq ostidan yangilansa forma qiymatlari
 * sakrardi.
 */
export function useNasHealth() {
  const query = useQuery({
    queryKey: queryKeys.nas.health,
    queryFn: ({ signal }) => fetchNasHealth(signal),
  // ⚠️ Avtoyangilanish OLIB TASHLANDI (egasi qarori 2026-08-20):
  //    u faqat bosh sahifada qoladi. Qolgan ekranlarda u backendga
  //    doimiy yuk berardi, holbuki operator sahifani ochiq qoldirib
  //    boshqa ish bilan band bo'ladi. Yangilash QO'LDA — tugma bor.
  })

  /**
   * `nasId` bo'yicha indeks — jadval katagi uchun.
   *
   * ⚠️ Kalit `nasId`, `nasname` EMAS: manzil tahrirlanishi mumkin va
   * o'zgargan paytda eski belgi boshqa qurilmaga yopishib qolardi.
   */
  const byId = useMemo(() => {
    const map = new Map<number, NasHealth>()
    for (const row of query.data?.rows ?? []) map.set(row.nasId, row)
    return map
  }, [query.data])

  return {
    query,
    byId,
    windowSeconds: query.data?.windowSeconds ?? null,
    /**
     * Reyestr BO'SHmi.
     *
     * ⚠️ `null` va `false` FARQLI: so'rov hali tugamagan yoki xato bergan
     * bo'lsa `null` — bunda "qurilma yo'q" degan ogohlantirish
     * KO'RSATILMAYDI. Yuklanish paytida halokat haqida xabar berish
     * har sahifa ochilishida yolg'on trevoga bo'lardi.
     *
     * ⚠️ Bu belgi QIDIRUVDAN mustaqil: `/api/nas/health` `q` parametrini
     * umuman olmaydi. Ro'yxatning bo'shligiga qarab xulosa qilish
     * "topilmadi" ni "qurilma yo'q" bilan chalkashtirardi.
     */
    registryEmpty: query.data ? query.data.rows.length === 0 : null,
  }
}
